module.exports = __webpack_public_path__ + "static/pauserecording4-9660bfaaf26b485d5003f73b20163d04.png";